import React, { useEffect, useRef, useState } from 'react'
import ContentLoader from 'react-content-loader'

interface Props {
  cols: number
  rows: number
  containerWidth: number
  loading: boolean
  children?: React.ReactNode
}

const Loader = ({
  cols,
  rows,
  containerWidth,
  loading: _loading,
  children,
}: Props) => {
  // Get values from props
  // const { rows, columns, coverHeight, coverWidth, padding, speed } = props;

  // Hardcoded values
  const coverHeight = containerWidth / cols
  const coverWidth = containerWidth / cols
  const speed = 1

  const covers = Array(cols * rows).fill(1)

  const [loading, setLoading] = useState(false)
  const timer = useRef(0)
  useEffect(() => {
    if (_loading) {
      setLoading(_loading)
      return
    }
    // 故意延迟lading状态，防止加载太快页面闪烁
    window.clearTimeout(timer.current)
    timer.current = window.setTimeout(() => {
      setLoading(_loading)
    }, 300)
  }, [_loading])

  if (!loading) return <>{children}</>

  return (
    <ContentLoader
      speed={speed}
      width={containerWidth}
      height={rows * coverHeight}
      foregroundColor="#242b34"
      backgroundColor="#343d4c"
      backgroundOpacity={0.3}
      foregroundOpacity={0.3}
    >
      {covers.map((g, i) => {
        let vy = Math.floor(i / cols) * coverHeight
        let vx = (i * coverWidth) % (cols * coverWidth)
        return (
          <rect
            key={i}
            x={vx}
            y={vy}
            rx="0"
            ry="0"
            width={coverWidth - 1}
            height={coverHeight - 1}
          />
        )
      })}
    </ContentLoader>
  )
}

export default Loader
